import React, { useState, useRef } from 'react';
import { motion, useInView, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-[#F3EDF7] last:border-b-0" data-id="element-34">
      <button onClick={onToggle} className="w-full py-6 flex items-center justify-between text-left" aria-expanded={isOpen} data-id="element-35">
        <span className="font-['Playfair_Display'] text-lg md:text-xl font-semibold text-[#2D2D2D] pr-4" data-id="element-36">
          {question}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="flex-shrink-0" data-id="element-37">
          <ChevronDownIcon className="w-6 h-6 text-[#B794C0]" data-id="element-38" />
        </motion.span>
      </button>

      <AnimatePresence data-id="element-39">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-40">
            <p className="pb-6 text-[#4A4A4A] leading-relaxed" data-id="element-41">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Funciona con niños pequeños?',
    answer: 'Sí, el sistema incluye swaps específicos para edades de 2 a 9 años. Cada etapa tiene sus propias estrategias adaptadas al desarrollo cognitivo y emocional de los niños.'
  }, {
    question: '¿Es un curso largo?',
    answer: 'No. Es un Ebook práctico y accionable. Puedes leerlo en una tarde y aplicar el primer Bloque BAD mañana mismo. Está diseñado para madres que no tienen tiempo que perder.'
  }, {
    question: '¿Necesito una oficina cerrada?',
    answer: 'No. El método está diseñado para ser usado incluso en la mesa del comedor. No necesitas un espacio físico separado, sino un sistema que funcione en tu realidad.'
  }];
  return <section ref={ref} className="w-full bg-white py-20 md:py-28" data-id="element-42">
      <div className="max-w-3xl mx-auto px-6" data-id="element-43">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        ease: 'easeOut'
      }} className="text-center mb-12" data-id="element-44">
          <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl lg:text-5xl font-bold text-[#2D2D2D]" data-id="element-45">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: 'easeOut'
      }} className="bg-[#FDF8F3] rounded-3xl p-6 md:p-10" data-id="element-46">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-47" />)}
        </motion.div>
      </div>
    </section>;
}